import React from 'react';
import {Box, Typography} from '@mui/material';
import {Icon, type IconName} from '@lightricks/react-design-system';
import styles from './DeveloperOverrideModal.module.scss';

interface EmptyStateProps {
  testID?: string;
  icon?: IconName;
  title: string;
  subtitle: string;
}

function EmptyState({
  testID = 'empty-state',
  icon = 'Actions-Alert-Line',
  title,
  subtitle,
}: EmptyStateProps) {
  return (
    <Box className={styles.emptyState} data-testid={testID}>
      <Icon
        size="large"
        appearance="neutral"
        name={icon}
        className={styles.emptyStateIcon}
      />
      <Typography variant="body1" className={styles.emptyStateText}>
        {title}
      </Typography>
      <Typography variant="body2" className={styles.emptyStateSubtext}>
        {subtitle}
      </Typography>
    </Box>
  );
}

export default EmptyState;
